import type { Forest } from './forest'

export type VisibleRow = { id: string; depth: number; hasChildren: boolean }

/** Pre-order walk that only descends into expanded nodes. Feeds a virtualizer. */
export const visibleRows = (
	forest: Forest<unknown>,
	expanded: ReadonlySet<string>
): VisibleRow[] => {
	const rows: VisibleRow[] = []
	const stack: { id: string; depth: number }[] = []
	for (let i = forest.roots.length - 1; i >= 0; i--) {
		stack.push({ id: forest.roots[i], depth: 0 })
	}
	while (stack.length) {
		const { id, depth } = stack.pop()!
		const children = forest.childrenOf.get(id) ?? []
		rows.push({ id, depth, hasChildren: children.length > 0 })
		if (expanded.has(id)) {
			for (let i = children.length - 1; i >= 0; i--) {
				stack.push({ id: children[i], depth: depth + 1 })
			}
		}
	}

	return rows
}
